import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import BookingCalendar from "./BookingCalendar";
import AdminDashboard from "./AdminDashboard";
import Auth from "./Auth";
import ActionPage from "./ActionPage";

// Постоянство сессии настраивается один раз в firebase.js. Раньше здесь висел
// setPersistence(), а до его резолва всё приложение показывало «Loading...»
// и подписка на пользователя не значила ничего — состояние user тут никому
// не передавалось. Слежение за авторизацией живёт в самих экранах.
function App() {
  return (
    <Router>
      <div className="App" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <div style={{ flex: "1 0 auto" }}>
          <Routes>
            <Route path="/" element={<BookingCalendar />} />
            <Route path="/en" element={<BookingCalendar />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/verify-email" element={<ActionPage />} />
          </Routes>
        </div>
   
      </div>
    </Router>
  );
}

export default App;
